import { useId, useState } from "react";
import { FileText, UploadCloud, X } from "lucide-react";

const defaultAccept =
  ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.webp,.zip";

const MaterialDropzone = ({
  files,
  onFilesChange,
  maxFiles = 5,
  accept = defaultAccept,
}: {
  files: File[];
  onFilesChange: (files: File[]) => void;
  maxFiles?: number;
  accept?: string;
}) => {
  const inputId = useId();
  const [dragActive, setDragActive] = useState(false);

  const addFiles = (nextFiles: FileList | File[]) => {
    const merged = [...files, ...Array.from(nextFiles)].slice(0, maxFiles);
    onFilesChange(merged);
  };

  const removeFile = (index: number) => {
    onFilesChange(files.filter((_, fileIndex) => fileIndex !== index));
  };

  return (
    <div>
      <label
        htmlFor={inputId}
        onDragEnter={(event) => {
          event.preventDefault();
          setDragActive(true);
        }}
        onDragOver={(event) => {
          event.preventDefault();
          setDragActive(true);
        }}
        onDragLeave={(event) => {
          event.preventDefault();
          setDragActive(false);
        }}
        onDrop={(event) => {
          event.preventDefault();
          setDragActive(false);
          addFiles(event.dataTransfer.files);
        }}
        className={`flex cursor-pointer flex-col items-center justify-center rounded-2xl border-2 border-dashed px-4 py-6 text-center transition ${
          dragActive
            ? "border-black bg-[#ffd400]/25"
            : "border-[#DCD7CF] bg-white hover:border-black hover:bg-[#fffdf2]"
        }`}
      >
        <input
          id={inputId}
          type="file"
          multiple
          accept={accept}
          onChange={(event) => addFiles(event.target.files || [])}
          className="sr-only"
        />
        <span className="grid h-11 w-11 place-items-center rounded-2xl border-2 border-black bg-[#ffd400] text-black shadow-[3px_3px_0_#000]">
          <UploadCloud size={22} />
        </span>
        <span className="mt-3 text-sm font-black text-black">
          Перетягни файли сюди
        </span>
        <span className="mt-1 text-xs font-semibold text-[#817A72]">
          або натисни, щоб вибрати вручну
        </span>
        <span className="mt-2 text-[11px] font-bold uppercase tracking-wide text-[#8a6f00]">
          до {maxFiles} файлів за раз
        </span>
      </label>

      {files.length > 0 && (
        <div className="mt-3 space-y-2">
          {files.map((file, index) => (
            <div
              key={`${file.name}-${file.size}-${index}`}
              className="flex min-w-0 items-center gap-3 rounded-xl border border-[#E8E1D8] bg-white px-3 py-2"
            >
              <FileText size={17} className="shrink-0 text-[#8a6f00]" />
              <span className="min-w-0 flex-1 truncate text-xs font-bold text-[#4E4943]">
                {file.name}
              </span>
              <button
                type="button"
                onClick={() => removeFile(index)}
                className="grid h-7 w-7 shrink-0 place-items-center rounded-lg border border-[#F2D3CD] bg-[#FFF6F4] text-[#9D3D2E]"
                aria-label="Прибрати файл"
              >
                <X size={14} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MaterialDropzone;
